import { render, staticRenderFns } from "./DialogPromotion.vue?vue&type=template&id=491d2148&scoped=true&lang=pug"
import script from "./DialogPromotion.vue?vue&type=script&lang=js"
export * from "./DialogPromotion.vue?vue&type=script&lang=js"
import style0 from "./DialogPromotion.vue?vue&type=style&index=0&id=491d2148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d2148",
  null
  
)

export default component.exports